// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageModal_modal__dXNNC .modal-content {
  max-height: 80vh;
  /* overflow-y: auto; */
}

.MessageModal_mainDiv__vtBi2 {
  padding: 0px 50px 50px 35px;
}

.MessageModal_header__S1zIs {
  padding: 30px 50px 0px 50px;
  background-color: var(--white-color) !important;
  border: none;
  color: var(--primary-color) !important;
}

.MessageModal_heading__334Tl {
  color: var(--black-dark-text-color) !important;
}

.MessageModal_buttonDiv__7wSIb {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.MessageModal_uploadImageContainerClass__E1UDB {
  width: 140px;
  height: 105px !important;
  background: var(--white-color-v1);
  border: 2px solid rgba(142, 142, 142, 0.45);
  border-radius: 7px;
}

.MessageModal_dropDownContainer__zHcCi > div > div > div {
  padding-left: 10px;
}

.MessageModal_buttonContainer__lhemw {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  position: absolute;
  top: -35px;
  right: 20px;
  z-index: 1;
}

.MessageModal_editButton__vda1F {
  border-radius: 10px !important;
}
.MessageModal_myLabel__8lSsW {
  font-size: 16px;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/MessageModal/MessageModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".modal :global(.modal-content) {\n  max-height: 80vh;\n  /* overflow-y: auto; */\n}\n\n.mainDiv {\n  padding: 0px 50px 50px 35px;\n}\n\n.header {\n  padding: 30px 50px 0px 50px;\n  background-color: var(--white-color) !important;\n  border: none;\n  color: var(--primary-color) !important;\n}\n\n.heading {\n  color: var(--black-dark-text-color) !important;\n}\n\n.buttonDiv {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.uploadImageContainerClass {\n  width: 140px;\n  height: 105px !important;\n  background: var(--white-color-v1);\n  border: 2px solid rgba(142, 142, 142, 0.45);\n  border-radius: 7px;\n}\n\n.dropDownContainer > div > div > div {\n  padding-left: 10px;\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  position: absolute;\n  top: -35px;\n  right: 20px;\n  z-index: 1;\n}\n\n.editButton {\n  border-radius: 10px !important;\n}\n.myLabel {\n  font-size: 16px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `MessageModal_modal__dXNNC`,
	"mainDiv": `MessageModal_mainDiv__vtBi2`,
	"header": `MessageModal_header__S1zIs`,
	"heading": `MessageModal_heading__334Tl`,
	"buttonDiv": `MessageModal_buttonDiv__7wSIb`,
	"uploadImageContainerClass": `MessageModal_uploadImageContainerClass__E1UDB`,
	"dropDownContainer": `MessageModal_dropDownContainer__zHcCi`,
	"buttonContainer": `MessageModal_buttonContainer__lhemw`,
	"editButton": `MessageModal_editButton__vda1F`,
	"myLabel": `MessageModal_myLabel__8lSsW`
};
export default ___CSS_LOADER_EXPORT___;
